import React from 'react';

const Watermark = () => (
  <svg width="122" height="160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M160 38.4v5.333a2.667 2.667 0 0 1-2.667 2.667h-8v4a4 4 0 0 1-4 4H14.667a4 4 0 0 1-4-4v-4h-8A2.667 2.667 0 0 1 0 43.733V38.4a2.667 2.667 0 0 1 1.647-2.464L78.98 6.603a2.666 2.666 0 0 1 2.04 0l77.333 29.333A2.667 2.667 0 0 1 160 38.4Zm-8 101.333H8a8 8 0 0 0-8 8v5.334a2.665 2.665 0 0 0 2.667 2.666h154.666a2.666 2.666 0 0 0 2.667-2.666v-5.334a8 8 0 0 0-8-8Zm-125.333-80v64h-12a4 4 0 0 0-4 4v6.667h138.666v-6.667a4 4 0 0 0-4-4h-12v-64H112v64H90.667v-64H69.333v64H48v-64H26.667Z"
      fill="#9AC4E1"
      opacity=".1"
    />
  </svg>
);

export default Watermark;
